'use strict';

function isOfferIdFound(offerId, premiumList) {
  return premiumList.some(
    ({ offerId: premiumOfferId }) => premiumOfferId === offerId
  );
}

function removePremiumOfferDuplicates(coupons, premiumOffer) {
  const result = { premiumList: [], couponList: coupons };

  if (premiumOffer && premiumOffer.offerId) {
    result.couponList = coupons.filter(
      ({ offerId }) => offerId !== premiumOffer.offerId
    );
    result.premiumList = [premiumOffer];
  }

  return result;
}

function groupPremiumOffers(coupons, limit = 1) {
  return coupons.reduce(
    (result, item) => {
      const { premiumList, couponList } = result;

      if (premiumList.length < limit && item.isPremiumOffer) {
        premiumList.push(item);
      } else if (!isOfferIdFound(item.offerId, premiumList)) {
        couponList.push(item);
      }

      return result;
    },
    { premiumList: [], couponList: [] }
  );
}

module.exports = { groupPremiumOffers, removePremiumOfferDuplicates };
